import * as React from 'react';
import { IAuthenticationProvider } from '../backend/interfaces/IAuthenticationProvider';

export const AppAuthenticationProviderContext = React.createContext<IAuthenticationProvider|null>(null);
